module.exports = __webpack_public_path__ + "img/book-blank.12e5b2c8.svg";